import { Divider, Grid } from '@material-ui/core'
import React from 'react'
import SpecificComponent from '../../commons/SpecificComponent'
import Utils from '../../providers/Utils'


import './Test.css'

import { ReactComponent as ThumbUp } from './MonitorizareIcons/thumb_up_black.svg';
import { ReactComponent as ThumbDown } from './MonitorizareIcons/thumb_down_black.svg';
import { ReactComponent as SportSoccer } from './MonitorizareIcons/sports_soccer_black.svg';
import { ReactComponent as HistoryToggle } from './MonitorizareIcons/history_toggle_off_black.svg';


export default class ClientAppointment extends SpecificComponent {

    constructor(props) {

        super(props)

        this.state = {
            name: 'React',
            data: {
                datasets: [{
                    data: [10, 20, 30]
                }],

            }
        }

    }

    u = new Utils()

    componentDidMount() {

        this.oreDisponibile()
    }


    ore = [
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ]

    programari = [

        {
            ora: '08:30',
            durata: '60'
        },

        {
            ora: '14:00',
            durata: '90'
        },

        {
            ora: '15:00',
            durata: '60'
        },
    ]



    // array care seamana cu cel de programari (obiecte) => fiecare ora din arr ore, disponibilitate in minute
    // ora ocupata = 0 sau negativ   

    oreDisponibile = () => {

        let disponibilitate = [];

        for (let i = 0; i < this.ore.length; i++) {


        }
    }


    oraLucruBackgroundColor = (ora) => {

        let idxOre = this.props.oreLucru.findIndex(o => o === ora)

        if (idxOre !== -1) {
            return '#438AFE'
        } else {
            return 'rgb(255	255	255)'
        }



    }



    render() {

        return (

            <div className="circle-container">

                <ul className="circle">

                    {this.props.appsToday.map((app, idx) => {
                        return (
                            <li
                                className='pm-monitor-chart-li'
                                style={{ backgroundColor: this.oraLucruBackgroundColor(app.hour) }}
                                onClick={() => { this.props.appsUsed(app) }} key={idx}>
                                <div className="text">
                                    <span>{app.hour}</span>



                                </div>




                                <div style={{ width: '100%', height: `${app.appProductive}%`, backgroundColor: 'rgb(0 179 46)', display: 'inline-block' }}>
                                </div>
                                <div style={{ width: '100%', height: `${app.appNeproductive}%`, backgroundColor: 'rgb(255 0	18)', display: 'inline-block' }}>
                                </div>
                                <div style={{ width: '100%', height: `${app.appIdle}%`, backgroundColor: 'rgb(255 227 0)', display: 'inline-block' }}>
                                </div>
                                <div style={{ width: '100%', height: `${app.pauzaOraProcent}%`, backgroundColor: 'rgb(255 156 0)', display: 'inline-block' }}>
                                </div>

                                {/* <p className="line"></p>
                            <p className="line"></p>
                            <p className="line"></p> */}



                            </li>
                        )
                    })}





                    <div className="center">

                        {this.props.appList}

                        {this.props.oraSelectata &&
                            <div className='ora-selectata-container'>
                                <div className='ora-selectata-label'>
                                {this.dictionary.monitorizare.ora} 
                                </div>
                                <div className='ora-selectata-interval'>
                                    {this.props.oraSelectata.oraStart} - {this.props.oraSelectata.oraFinish}
                                </div>
                            </div>
                        }


                        <Grid style={{
                            width: '40%', margin: 'auto',
                            boxShadow: '2px 2px 7px 0px rgb(226 224 224)',
                            WebkitBoxShadow: '2px 2px 7px 0px rgb(226 224 224)',
                            overflow: 'hidden',
                            borderRadius: 5,
                            position: 'absolute',
                            top: 214,
                            right: 56

                        }} container>
                            <Grid style={{ backgroundColor: 'rgb(53	113	253)', textAling: 'center', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', color: 'white', margin: 0, fontSize: 16 }} >{this.dictionary.monitorizare.distributiaTimpului} </h5>


                            </Grid>




                            <Grid style={{

                            }} item xs={12} sm={12} md={12} lg={12} xl={12} >







                                <Grid style={{ paddingTop: 10 }} container>
                                    <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                        <div style={{ fontWeight: 600 }}>

                                            <div
                                                style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                            >
                                                <span style={{ fontWeight: 500, fontSize: 12 }}> 
                                                <ThumbUp style={{ width: 18, height: 18, }} />
                                                  </span>

                                            </div>

                                            <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpProductiv} </span><br />

                                        </div>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500}}>    {this.u.secondsToMinute(this.props.aplicatiiFolositeIntervalOre.appProductiveTime)}</span>
                                    </Grid>

                                    <Divider style={{ marginTop: 10, backgroundColor:'#F2F2F2' }} className="pm-divider" />
                                </Grid>

                                <Grid style={{ paddingTop: 10 }} container>
                                    <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                        <div style={{ fontWeight: 600 }}>

                                            <div
                                                style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                            >
                                                <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                <ThumbDown style={{ width: 18, height: 18, }} />
                                                     </span>

                                            </div>

                                            <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpNeproductiv} </span><br />

                                        </div>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(this.props.aplicatiiFolositeIntervalOre.appNeproductiveTime)}</span>
                                    </Grid>

                                    <Divider style={{ marginTop: 10, backgroundColor:'#F2F2F2' }} className="pm-divider" />
                                </Grid>

                                <Grid style={{ paddingTop: 10 }} container>
                                    <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                        <div style={{ fontWeight: 600 }}>

                                            <div
                                                style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                            >
                                                <span style={{ fontWeight: 500, fontSize: 12 }}> 
                                                <HistoryToggle style={{ width: 18, height: 18, }} />
                                                  </span>

                                            </div>

                                            <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpMort} </span><br />

                                        </div>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500}}>    {this.u.secondsToMinute(this.props.aplicatiiFolositeIntervalOre.appIdleTime)}</span>
                                    </Grid>

                                    <Divider style={{ marginTop: 10, backgroundColor:'#F2F2F2' }} className="pm-divider" />
                                </Grid>

                                <Grid style={{ paddingTop: 10, marginBottom: 10 }} container>
                                    <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                        <div style={{ fontWeight: 600 }}>

                                            <div
                                                style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                            >
                                                <span style={{ fontWeight: 500, fontSize: 12 }}> 
                                                <SportSoccer style={{ width: 18, height: 18, }} />
                                                 </span>

                                            </div>

                                            <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.pauza} </span><br />

                                        </div>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <span className='pm-monitorizare-normal-text' style={{ fontWeight: 500}}>    {this.u.secondsToMinute(this.props.aplicatiiFolositeIntervalOre.pauzaOraTime) }</span>
                                    </Grid>


                                </Grid>



                            </Grid>
                        </Grid>


                    </div>

                </ul>

            </div>
        )
    }
}